import { PageType } from "../app/slice/appSlice.model";
import { ConditionFact } from "../hooks/useEditCondition";
import { getConditionsMetaData } from "./conditionsMetaData";

export const getConditionVerbose = (
  activePage: PageType,
  isShopifyPlusMerchant: boolean,
  conditionFact: ConditionFact | undefined,
  value: string,
) => {
  const conditionKey = conditionFact as ConditionFact;
  const operatorOneValue = getConditionsMetaData(activePage, isShopifyPlusMerchant, value);

  switch (conditionFact) {
    case ConditionFact.CUSTOMER_COUNTRY:
      return "Customer country";

    case ConditionFact.CUSTOMER_LANGUAGE:
      return "Language";

    case ConditionFact.DISCOUNT_CODE:
      return "Discount code";

    case ConditionFact.CART_OR_ORDER_VALUE:
      return "Cart/Order value";

    default:
      return `${operatorOneValue[conditionKey]?.options?.find((val: any) => val?.value === value)?.label}`;
  }
};

export const getConditionOperatorVerbose = (
  activePage: PageType,
  isShopifyPlusMerchant: boolean,
  conditionFact: ConditionFact | undefined,
  conditionValue: string,
  operatorValue: string,
  value: any,
  itemsInfo: any,
  currencySymbol: string,
) => {
  const conditionKey = conditionFact as ConditionFact;
  const operatorOneValue = getConditionsMetaData(activePage, isShopifyPlusMerchant, conditionValue);

  const operatorLabel = operatorOneValue[conditionKey]?.operatorOptions
    ?.find((val: any) => val?.value === operatorValue)
    ?.label?.toLocaleLowerCase();

  switch (conditionFact) {
    case ConditionFact.SPECIFIC_PRODUCT:
      return `${operatorLabel}`;

    case ConditionFact.CART_OR_ORDER_VALUE:
      return `${operatorLabel} <span style="font-weight: 600;">${value?.length > 0 ? `${value[0]}${currencySymbol} and ${value[1]}${currencySymbol}` : `${value}${currencySymbol}`}</span>`;

    case ConditionFact.PRODUCT_SKU:
      switch (operatorValue) {
        case "isExactSame":
          return `is (exact SKU) <span style="font-weight: 600;">${value}</span>`;

        case "isNotExactSame":
          return `is not (exact SKU) <span style="font-weight: 600;">${value}</span>`;

        default:
          return `${operatorLabel} <span style="font-weight: 600;">${value}</span>`;
      }

    case ConditionFact.CUSTOMER_LANGUAGE:
    case ConditionFact.CUSTOMER_COUNTRY:
    case ConditionFact.PRODUCT_TAGS:
    case ConditionFact.PRODUCT_SALES_CHANNEL:
      return `${operatorLabel} <span style="font-weight: 600;">${itemsInfo?.join(", ")}</span>`;

    case ConditionFact.PREV_PAGE_OFFER:
      return `${operatorLabel}`;

    default:
      return `${operatorLabel} <span style="font-weight: 600;">${value}</span>`;
  }
};

export const getProductToDisplayVerbose = (value: String) => {
  switch (value) {
    case `SHOPIFY_RECOMMENDATIONS`:
      return `Shopify Recommendations`;

    case `MOST_EXPENSIVE`:
      return `Most expensive product in the cart`;

    case `LEAST_EXPENSIVE`:
      return `Cheapest product in the cart`;

    case `WISER_RECOMMENDATIONS`:
      return `Wiser recommendations`;

    case `PERSONALIZED_RECOMMENDATIONS`:
      return `Personalized recommendations`;

    case `REBUY_INTELLIGENT_CROSS_SELL`:
      return `Rebuy intelligent cross sell`;

    case `RECOMATIC_RECOMMENDATIONS`:
      return `Recomatic recommendations`;

    default:
      break;
  }
};
